<h1 mat-dialog-title *ngIf="AddQuestion == true">Add Question</h1>
<h1 mat-dialog-title *ngIf="AddQuestion != true && AddSection != true && EditSection != true">Edit Question</h1>
<h1 mat-dialog-title *ngIf="AddSection == true">Add Section</h1>
<h1 mat-dialog-title *ngIf="EditSection == true">Edit Section</h1>





<div mat-dialog-content style="display: flex;flex-direction: column;">


  <div class="example-full-width" style="display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;margin-top: 12px;">
    <mat-label style="font-weight: bold;" class="get-label">Title</mat-label>

    <mat-form-field class="action-input">
      <input  type="text" matInput placeholder="Title" [(ngModel)]="Title" class="get-Input">
    </mat-form-field>

    
  </div>

  <div *ngIf="AddSection != true && EditSection != true" class="example-full-width" style="display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;">
    <mat-label style="font-weight: bold;" class="get-label">Description</mat-label>

    <mat-form-field class="action-input">
      <input  type="text" matInput placeholder="Description" [(ngModel)]="Description"
      class="get-Input">
    </mat-form-field>

    
  </div>

  <div *ngIf="AddSection != true && EditSection != true" style="display: flex;flex-direction: row;justify-content: space-between;align-items: center;height: 40px;">
    <div style="display: flex;flex-direction: row;flex:1;height: 40px;align-items: center;">
      <span style="font-weight: bold;">Question Type</span>
    </div>

    <mat-form-field class="action-input">
      <mat-select  placeholder="Select Answer Type" [(ngModel)]="QuestionType">

        <mat-option *ngFor="let _type of data.QuestionTypes" [value]="_type.Id">
          {{_type.Title}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- <div style="display: flex;flex-direction: row;flex:1;align-items: center;">
      
    </div> -->
  </div>

</div>

<div mat-dialog-actions class="dialogControllBtn">
  <a class="button button--primary" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
  <button style="margin-left: 20px;" class="button button--primary" (click)="onSubmitClick()" cdkFocusInitial><span
      class="button__text">Submit</span></button>
</div>